import Immutable from 'seamless-immutable';
import _ from 'lodash';

const REQUEST_IN_PROGRESS = 'REQUEST_IN_PROGRESS';
const REQUEST_FINISHED = 'REQUEST_FINISHED';
const SET_CODE_RESPONSE = 'SET_CODE_RESPONSE';
const INIT_STATE = 'INIT_STATE';

const reducerName = `requestStatus`;
const createReducerDotPathName = combineName => `${combineName}.${reducerName}`;

const createActionName = (parentName, name) =>
  `app/${createReducerDotPathName(parentName)}/${name}`;
export const getState = (state, parentName) =>
  _.get(state, createReducerDotPathName(parentName));

const createRequestStatusReducer = parentName => {
  function stateDefault() {
    return {
      requestInProcess: false,
      codeResponse: null
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(parentName, REQUEST_IN_PROGRESS):
        return state.merge({
          requestInProcess: true,
          codeResponse: null
        });
      case createActionName(parentName, REQUEST_FINISHED):
        return state.merge({
          requestInProcess: false
        });
      case createActionName(parentName, SET_CODE_RESPONSE):
        return state.merge({
          codeResponse: action.payload
        });
      case createActionName(parentName, INIT_STATE):
        return Immutable(stateDefault());
      default:
        return state;
    }
  };
};
export function createReduceObject(parentName) {
  const reduceObject = {};
  reduceObject[reducerName] = createRequestStatusReducer(parentName);
  return reduceObject;
}

// ACTION CREATOR
export const requestInProcess = parentName => ({
  type: createActionName(parentName, REQUEST_IN_PROGRESS)
});
export const requestFinished = parentName => ({
  type: createActionName(parentName, REQUEST_FINISHED)
});
export const setCodeResponse = (parentName, payload) => ({
  type: createActionName(parentName, SET_CODE_RESPONSE),
  payload
});
export const initState = parentName => ({
  type: createActionName(parentName, INIT_STATE)
});

// SELECTORS
export const selectRequestStatusData = (parentName, state) =>
  getState(state, parentName);



// WEBPACK FOOTER //
// ./src/mt-react-common/common/reducers/_requestStatus/reducer.js